"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminInviteUserToCommunityPoolResponseToJSON = exports.AdminInviteUserToCommunityPoolResponseFromJSONTyped = exports.AdminInviteUserToCommunityPoolResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function AdminInviteUserToCommunityPoolResponseFromJSON(json) {
    return AdminInviteUserToCommunityPoolResponseFromJSONTyped(json, false);
}
exports.AdminInviteUserToCommunityPoolResponseFromJSON = AdminInviteUserToCommunityPoolResponseFromJSON;
function AdminInviteUserToCommunityPoolResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'invitedAt': !(0, runtime_1.exists)(json, 'invitedAt') ? undefined : (new Date(json['invitedAt'])),
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.AdminInviteUserToCommunityPoolResponseFromJSONTyped = AdminInviteUserToCommunityPoolResponseFromJSONTyped;
function AdminInviteUserToCommunityPoolResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'userId': value.userId,
        'invitedAt': value.invitedAt === undefined ? undefined : (value.invitedAt.toISOString()),
        'message': value.message,
    };
}
exports.AdminInviteUserToCommunityPoolResponseToJSON = AdminInviteUserToCommunityPoolResponseToJSON;
